import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const miniflux = defineConnector({
  identifier: "miniflux",
  name: "Miniflux",
  tagLine: "Minimalist RSS reader",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) =>
    headerAuth([{ name: "X-Auth-Token", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Miniflux details",
      items: [
        {
          kind: "url",
          label: "Server URL",
          required: true,
          placeholder: "https://miniflux.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Miniflux instance.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Miniflux, go to **Settings → API Keys** and create a new API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/v1/me`,
  },
});
